module.exports = __webpack_public_path__ + "img/ktb.9d337564.jpg";